import React from "react"
import ProductModelBase from "theme/base/shop/ProductModel"
import { Icon } from "semantic-ui-react"
import shop from "shop/shop"

export default class ProductModel extends ProductModelBase {
  
  constructor( data ) {
    super( data );
    this.isSale = data.pinfos && !!data.pinfos.rabatt
    
    if ( this.cats && this.cats.length > 0 ) {
      let sortedCategories = this.cats && this.cats.sort( ( c0, c1 ) => {
        let a = c0.cat_id
        let b = c1.cat_id
        if ( a.length > b.length ) return -1
        if ( a.length < b.length ) return 1
        return a > b ? -1 : 1
      } )
      const cat_id = sortedCategories[ 0 ].cat_id
      this.category = shop.categoriesById.get( cat_id )
      if ( !this.category ) {
        console.error( "No Category found:", this.map_id, { cat_id } )
        this.category = {}
      }
    }
    
    this.canBeBought = true
  }
  
  getNotice = ( size ) => {
    const notice = <AvailabilityNotice size={size} product={this}/>
    return notice
  }

  validateCount( count ) {
    /*if ( this.extraValue.orderable) return true
    if ( !this.extraValue.orderable ) {
      return this.stock >= count
    }*/
    return true
  }
}




function AvailabilityNotice( { product, size } ) {
  let text = product.extraValue.stockText || translate( "Auf Lager" )
  let color = product.extraValue.stockColor || "green"
  
  if ( size === "tiny" ) {
    return <div className={"Availability"}>
      <span className={""}><Icon title={text} name="truck" color={color}/> {text}</span>
    </div>
  }
  
  return <div className={"Availability"}>
    <span className={""}><Icon title={text} name="truck" color={color}/> {text}</span>
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/shop/ProductModel.js